// extracted by mini-css-extract-plugin
export default {"title":"r_-z","warning":"s_-z","sizeOptionsLegendText":"t_-z"};